import { faFile } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CellCenter, TableInMem } from 'motion-components';
import React from 'react';
import { Button, Modal, ModalProps } from 'react-bootstrap';
import { createModal } from 'react-modal-promise';
import { useTranslation } from 'react-i18next';

type Props = {
  readonly open: boolean;
  readonly close: (result: boolean | number) => void;
  readonly title: string;
  /** body of dialog */
  readonly text: string; // | React.ReactNode;
  readonly data: any;
  readonly newData: any;
} & ModalProps;

const ModalSelectCp = ({ open, close, title, text, data, newData }: Props) => {
  const columns = [
    {
      /* ΚΟΛΩΝΑ ΜΕ RedEye και Click handler */
      id: 'select',
      Header: () => <FontAwesomeIcon icon={faFile} />,
      Cell: ({ row }) => (
        <div
          className="text-center"
          style={{ cursor: 'pointer' }}
          onClick={() => {
            close(row.original.id);
          }}
        >
          <Button style={{ width: '70px' }} variant="primary" type="button">
            {' Επιλογή '}
          </Button>
        </div>
      ),
      Footer: () => {
        return (
          <div
            className="text-center"
            style={{ cursor: 'pointer' }}
            onClick={() => {
              close(-1);
            }}
          >
            <Button style={{ width: '70px' }} variant="success" type="button">
              {' Νέο Σημείο '}
            </Button>
          </div>
        );
      },
    },
    {
      Header: 'Επωνυμία',
      accessor: 'name',
      Cell: ({ row }) => {
        const extraClass = row.original?.name === newData?.name ? ' font-weight-bold' : '';
        return <div className={'text-left' + extraClass}>{row.original?.name}</div>;
      },
      Footer: () => {
        return <div className="text-left font-weight-bold">{newData?.name}</div>;
      },
    },
    {
      Header: 'Α.Φ.Μ.',
      accessor: 'vatin',
      Cell: ({ row }) => {
        const extraClass =
          row.original?.vatNumber === newData?.vatNumber ? ' font-weight-bold' : '';
        return <div className={'text-center' + extraClass}>{row.original?.vatNumber}</div>;
      },
      Footer: () => {
        return <div className="text-center font-weight-bold">{newData?.vatNumber}</div>;
      },
    },
    {
      Header: 'Τηλέφωνο',
      accessor: 'phone',
      Cell: ({ row }) => {
        const extraClass =
          row.original?.phoneNumber1 === newData?.phoneNumber1 ? ' font-weight-bold' : '';
        return <div className={'text-center' + extraClass}>{row.original?.phoneNumber1}</div>;
      },
      Footer: () => {
        return <div className="text-center font-weight-bold">{newData?.phoneNumber1}</div>;
      },
    },
    {
      Header: 'Διεύθυνση',
      accessor: 'address',
      Cell: ({ row }) => (
        <>
          <div className="text-center">{row.original?.addressLine1}</div>
        </>
      ),
      Footer: () => {
        return (
          <>
            <div className="text-center font-weight-bold">{newData?.addressLine1}</div>
          </>
        );
      },
    },
    {
      Header: 'Τ.Κ.',
      accessor: 'postalCode',
      Cell: ({ row }) => {
        const extraClass =
          row.original?.postalCode === newData?.postalCode ? ' font-weight-bold' : '';
        return (
          <>
            <div className={'text-center' + extraClass}>{row.original?.postalCode}</div>
          </>
        );
      },
      Footer: () => {
        return (
          <>
            <div className="text-center font-weight-bold">{newData?.postalCode}</div>
          </>
        );
      },
    },
  ];
  const { t } = useTranslation();
  return (
    <>
      <Modal show={open} size="lg" centered backdrop="static">
        <Modal.Header>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <TableInMem
            title={text}
            propPageSize={10}
            onCreate={undefined}
            columns={columns}
            data={data}
            hasSearch={false}
            hasFooter={true}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="p-3"
            style={{ minWidth: '5rem' }}
            variant="danger"
            onClick={() => close(false)}
          >
            &nbsp;{t('Ακύρωση')}&nbsp;
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

const promiseModalSelectCp = createModal(ModalSelectCp);

export default promiseModalSelectCp;

